import { render, staticRenderFns } from "./CreateAsset.vue?vue&type=template&id=57e89922&"
import script from "./CreateAsset.vue?vue&type=script&lang=js&"
export * from "./CreateAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports